export default __webpack_public_path__ + "static/media/kunal_gupta.8c5c699a.jpg";